/** @file restClip: a clip with no keys or tracks, so the runtime draws the rest pose (Quads mode's A-pose). */
import type { Clip } from '@zilo/pose3d-format/types/clip';

/**
 * `clip` without keys, frame-key tracks or a mirrored half: every node samples its rest (identity) locals, as with no
 * clip on the playhead; name, fps and category stay, so the instance plays it under the same name.
 */
export function restClip(clip: Clip): Clip {
  const out: Clip = { ...clip, keys: [], mirrorHalf: false };
  delete out.tracks;
  return out;
}
